import React from 'react'

const Sizechart = () => {
  return (
    <div>Sizechart</div>
  )
}

export default Sizechart